import React, { useState } from 'react';
import './VendorSingle.css';

// Import necessary components
import { Comments, Faqs, Lightbox, PageSidebar, PageTitle } from '../../../components';
import { calculateAverageRating } from '../../../utils';

import { useLocation } from 'react-router-dom';

// Import FontAwesome icon
import { FaArrowRight, FaCheck, FaStar } from 'react-icons/fa';



const VendorSingle = () => {

  // State to manage the active tab (e.g., overview, details, etc.)
  const [activeTab, setActiveTab] = useState('overview');

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Get vendor data passed from the previous page
  const location = useLocation();
  const vendor = location.state;

  // Calculate the average rating of the vendors based on user reviews
  const averageRating = calculateAverageRating(vendor);

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    event.target.reset(); // Reset the form fields
  };

  return (
    <>

      {/* Page Title Section */}
      <PageTitle title={vendor.title} page={'Vendor Single'} />

      <section className='vendor-single page-single'>

        <div className="vendor-info page-info">

          {/* Vendor Image */}
          <div className="image">
            <img src={vendor.image} alt={vendor.title} />
          </div>

          {/* Vendor Content */}
          <div className="content tab-info">

            {/* Vendor Info Tabs - Tab Buttons */}
            <div className="vendor-info-tabs tab-buttons">
              <button 
                type="button" 
                className={`button ${activeTab === 'overview' ? 'active' : ''}`} 
                onClick={() => handleTabClick('overview')}
              >
                Overview
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'faqs' ? 'active' : ''}`} 
                onClick={() => handleTabClick('faqs')}
              >
                FAQs
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'location' ? 'active' : ''}`} 
                onClick={() => handleTabClick('location')}
              >
                Location
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'gallery' ? 'active' : ''}`} 
                onClick={() => handleTabClick('gallery')}
              >
                Gallery
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'reviews' ? 'active' : ''}`} 
                onClick={() => handleTabClick('reviews')}
              >
                Reviews
              </button>
            </div>

            {/* Vendor Info Tabs - Tab Sections */}
            <div className="tab-sections">

              {/* Overview Tab Section */}
              {activeTab === 'overview' && (

                <div className="overview" id="overview">

                  {/* Vendor heading */}
                  <h3 className='main-heading'>{vendor.title}</h3>

                  {/* Vendor rating */}
                  <div className='vendor-rating'>
                    <div className='icon'>
                        {/* Display star icons for rating */}
                        <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
                    </div>
                    {/* Display average rating and number of comments */}
                    {vendor.comments.length > 0 ? (
                        <h5>{averageRating} ({vendor.comments.length})</h5>
                    ) : (
                        <h5>Not rated</h5>
                    )}
                  </div>

                  {/* Vendor Content */}
                  {vendor.overviews.map((overview, index) => (
                    <p key={index}>{overview}</p>
                  ))}

                  {/* Experience & Expertise */}
                  <div className='sub-section'>

                    <h3 className='sub-heading'>Experience & Expertise:</h3>
                    <p>Key highlights and expert insights from the {vendor.title} service, ensuring an unforgettable and seamless experience for your event.</p>

                    {/* List of Expertise */}
                    <ul>
                      {vendor.experience.map((item, index) => {
                        return <li key={index}><div className='icon'><FaArrowRight /></div>{item}</li>
                      })}
                    </ul>
        
                  </div>

                  {/* Services Offered */}
                  <div className='sub-section'>

                    <h3 className='sub-heading'>Services Offered:</h3>
                    <p>Discover the exclusive services provided by {vendor.title}, ensuring an unforgettable experience for your special occasion:</p>

                    {/* List of Services */}
                    <ul>
                      {vendor.services.map((service, index) => {
                        return <li key={index}><div className='icon'><FaCheck /></div> {service}</li>
                      })}
                    </ul>

                  </div>

                </div>
              )}

              {/* Vendor FAQs Tab Section */}
              {activeTab === 'faqs' && (
                <div className="vendor-faqs" id="faqs">

                  {/* Faq Accordion container */}
                  <Faqs faqs={vendor.faqs} />

                </div>

              )}

              {/* Location Tab Section */}
              {activeTab === 'location' && (
                <div className="vendor-location">
                  <p>{vendor.location.description}</p>
                  <iframe
                  src={vendor.location.map}
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  title="Vendor Location Map"
                ></iframe> 
                </div>
              )}

              {/* Gallery Tab Section */}
              {activeTab === 'gallery' && (
                <Lightbox images={vendor.gallery} />
              )}

              {/* Reviews Tab Section */}
              {activeTab === 'reviews' && (
                <div className="reviews" id="reviews">

                  {/* Reviews */}
                  <Comments comments={vendor.comments} />

                  <div className='product-review'>
                    {/* Leave a Comment Form */}
                    <form className='form' onSubmit={handleSubmit}>

                      <h2>leave a comment</h2> {/* Comment Form Title */}

                      <div className='input-box'>
                        <input type="text" name="name" className='box' id="name" placeholder="name" required /> {/* Name Input Field */}
                        <input type="email" name="email" className='box' id="email" placeholder="email" required /> {/* Email Input Field */}
                      </div>
                      
                      <textarea cols="30" rows="10" name="comment" className='box' id="comment" placeholder="comment"></textarea> {/* Comment Textarea */}
                      
                      <button type="submit" name="submit" id="submit" className='btn'>submit</button> {/* Submit Button */}

                    </form>

                  </div>

                </div>
              )}

            </div>
          </div>
        </div>

        {/* Sidebar Section */}
        <PageSidebar
          heading={'Vendor'}
          details={vendor.details}
          button={{ link: 'Booking', title: 'Book Now' }}
        />

      </section>

    </>
  );
};

export default VendorSingle;